// ** React Imports
import { Link } from 'react-router-dom';

// ** Custom Components
import Avatar from '@components/avatar';

import {
  Badge,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown
} from 'reactstrap';
import { permissionsOptions } from '../../utility/Options';
import { Edit2, MoreVertical, Trash2 } from 'react-feather';

// ** Renders Client Columns
const renderClient = (row) => {
  return (
    <Avatar
      initials
      className="me-1"
      color={'light-primary'}
      content={row.fullName || ''}
    />
  );
};

// ** Renders Client Columns
const renderPermissions = (row) => {
  let concat = '';
  row.map((item) => {
    const option = permissionsOptions.find((e) => e.value === item);
    concat = `${concat} ${option.label} -`;
  });
  return <span>{concat}</span>;
};

const statusObj = {
  ACTIVE: 'light-success',
  INACTIVE: 'light-secondary'
};

export const columns = ({ handleUpdate, handleDelete }) => [
  {
    name: 'Usuario',
    sortable: true,
    minWidth: '270px',
    sortField: 'fullName',
    selector: (row) => row.fullName,
    cell: (row) => (
      <div className="d-flex justify-content-left align-items-center">
        {renderClient(row)}
        <div className="d-flex flex-column">
          <Link
            to={`/users/view/${row._id}`}
            className="user_name text-truncate text-body"
          >
            <span className="fw-bolder">
              {row?.fullName || 'No completado'}
            </span>
          </Link>
          <small className="text-truncate text-muted mb-0">{row.email}</small>
        </div>
      </div>
    )
  },
  {
    name: 'TELEFÓNO',
    minWidth: '150px',
    sortable: true,
    sortField: 'phone',
    selector: (row) => row.phone,
    cell: (row) => <span className="text-capitalize">{row.phone}</span>
  },
  {
    name: 'SECCIONES',
    minWidth: '400px',
    sortable: true,
    sortField: 'permissions',
    selector: (row) => row.phone,
    cell: (row) => renderPermissions(row.permissions)
  },
  {
    name: 'Estado',
    minWidth: '138px',
    sortable: true,
    sortField: 'status',
    selector: (row) => row.status,
    cell: (row) => (
      <Badge className="text-capitalize" color={statusObj[row.status]} pill>
        {row.status}
      </Badge>
    )
  },
  {
    name: '',
    minWidth: '50px',
    cell: (row) => (
      <div className="column-action">
        <UncontrolledDropdown>
          <DropdownToggle tag="div" className="btn btn-sm">
            <MoreVertical size={14} className="cursor-pointer" />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              tag="a"
              href="/"
              className="w-100"
              onClick={(e) => handleUpdate({ e, row })}
            >
              <Edit2 size={14} className="me-50" />
              <span className="align-middle">Editar</span>
            </DropdownItem>
            <DropdownItem
              tag="a"
              href="/"
              className="w-100"
              onClick={(e) => handleDelete({ e, row })}
            >
              <Trash2 size={14} className="me-50" />
              <span className="align-middle">Eliminar</span>
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    )
  }
];
